<template functional>
    <div
        :style="$options.styles"
        class="a-logo"
    >
        <button
            type="button"
            class="logo-button"
            @click="$options.redirectToHome"
            :aria-label="$options.params.ariaLabel"
        >
            <span
                v-if="$options.params.textLogo"
                class="logo-title"
            >
                {{ $options.params.textLogoTitle }}
            </span>
            <img
                v-else-if="$options.logo"
                :src="$options.logo"
                :alt="$options.params.alt"
            >
        </button>
    </div>
</template>

<script>
import { TERMINAL_START } from '@/utils/constants/pages'

import store from "@/store";
import router from '@/router';

export default {
    name: 'ALogo',

    props: {
        view: {
            type: String,
            default: ''
        }
    },

    logo: store.getters.getMap?.files?.logo,
    params: store.getters.getMapConfigProp('components.ALogo.params') || {},
    styles: store.getters.getMapConfigProp('components.ALogo.styles') || {},
    redirectToHome() {
        if (router.currentRoute.name === TERMINAL_START) {
            return;
        }
        router.push({
            name: TERMINAL_START
        });
    }
}
</script>

<style lang="scss">
@import "a-logo";
</style>
